export default {"src":"/polygon/_next/static/media/angels-mobile.de30c74e.svg","height":14,"width":13};